/** Global keyboard shortcuts: `n` opens the new-basket flow, `/` focuses the search box. */
import { useEffect } from "react";

type ShortcutHandlers = {
  readonly onNewBasket: () => void;
  readonly onFocusSearch: () => void;
};

function isTypingTarget(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false;
  const tag = target.tagName;
  return tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT" || target.isContentEditable;
}

export function useGlobalShortcuts({ onNewBasket, onFocusSearch }: ShortcutHandlers): void {
  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      if (isTypingTarget(e.target)) return;
      if (e.key === "n") {
        e.preventDefault();
        onNewBasket();
      } else if (e.key === "/") {
        e.preventDefault();
        onFocusSearch();
      }
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [onNewBasket, onFocusSearch]);
}
